// @ts-ignore
import { Face3, Geometry } from "oc-threejs/geometries/Geometry";
// @ts-ignore
import { forcePatch, monkeyPatch } from "oc-commons/extensions/monkeyPatch";
import "./SubdivisionModifier";
import { Intersection, Object3D, Raycaster, Scene } from "three";

declare const STAGE: any;

const _oldSceneClone = (Scene.prototype as any).clone;
(Scene.prototype as any).clone = function (this: any) {
  const clone = _oldSceneClone.apply(this);
  if (this.animationClips) clone.animationClips = this.animationClips;

  return clone;
};

interface RaycasterExtensions {
  ascSort: (a: Intersection, b: Intersection) => number;
  isVisibleAllParents: (object: Object3D) => boolean;
  isVisible: (object: Object3D) => boolean;
  _intersectObject: (object: Object3D, intersects: Intersection[], recursive?: boolean) => void;
  intersectObject: (
    object: Object3D,
    recursive?: boolean,
    intersects?: Intersection[],
  ) => Intersection[];
  intersectObjects: (
    objects: Object3D[],
    recursive?: boolean,
    intersects?: Intersection[],
  ) => Intersection[];
  setLineDefault: () => void;
}

forcePatch(Raycaster.prototype, {
  ascSort(a: Intersection, b: Intersection) {
    return a.distance - b.distance;
  },

  isVisibleAllParents(object: Object3D) {
    let o: Object3D | null = object;
    while (true) {
      if (!o) return true;
      o = o.parent;
      if (o == null) {
        return true;
      }
      if (!(this as any).isVisible(o)) {
        return false;
      }
    }
  },

  isVisible(object: Object3D) {
    return object.visible && object.layers.test(this.layers);
  },

  // object.visible ist hier die wesentliche Änderung
  _intersectObject(object: Object3D, intersects: Intersection[], recursive: boolean = true) {
    if ((this as any).isVisible(object)) {
      object.raycast(this as any, intersects);
      if (recursive) {
        object.children.forEach((child) => {
          (this as any)._intersectObject(child, intersects, true);
        });
      }
    }
  },

  // nur zum Überschreiben von _intersectObject da...
  intersectObject(object: Object3D, recursive?: boolean, intersects: Intersection[] = []) {
    (this as any).setLineDefault();
    if ((this as any).isVisibleAllParents(object)) {
      (this as any)._intersectObject(object, intersects, recursive);
      intersects.sort((this as any).ascSort);
    }
    return intersects;
  },

  // nur zum Überschreiben von _intersectObject da...
  intersectObjects(objects: Object3D[], recursive?: boolean, intersects: Intersection[] = []) {
    (this as any).setLineDefault();
    if (Array.isArray(objects) === false) {
      console.warn("THREE.Raycaster.intersectObjects: objects is not an Array.");
      return intersects;
    }
    objects.forEach((object) => {
      if ((this as any).isVisibleAllParents(object)) {
        (this as any)._intersectObject(object, intersects, recursive);
      }
    });
    intersects.sort((this as any).ascSort);
    return intersects;
  },

  setLineDefault() {
    if (typeof STAGE !== "undefined") {
      (this as any).params.Line.threshold = STAGE.settings.raycaster.linePrecision;
    }
  },
});
